/**
 * Swagger Lucor
 * Swagger Lucor
 *
 * OpenAPI spec version: 1.2.18
 * Contact: roger.cazangi@hotmail.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { Evento } from '../model/evento';
import { FiltroNotificacoes } from '../model/filtroNotificacoes';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';

import { environment } from '../../environments/environment';


@Injectable()
export class NotificacoesApiService {

    protected basePath = environment.apiBasePath;
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Pesquisar Notificações
     * 
     * @param desde 
     * @param ate 
     * @param pessoaJuridicaId 
     * @param apenasPendentes 
     * @param entidadeId 
     * @param urlContains 
     * @param ids 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1NotificacoesGet(desde?: Date, ate?: Date, pessoaJuridicaId?: number, apenasPendentes?: boolean, entidadeId?: number, urlContains?: string, ids?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<Evento>>;
    public v1NotificacoesGet(desde?: Date, ate?: Date, pessoaJuridicaId?: number, apenasPendentes?: boolean, entidadeId?: number, urlContains?: string, ids?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Evento>>>;
    public v1NotificacoesGet(desde?: Date, ate?: Date, pessoaJuridicaId?: number, apenasPendentes?: boolean, entidadeId?: number, urlContains?: string, ids?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Evento>>>;
    public v1NotificacoesGet(desde?: Date, ate?: Date, pessoaJuridicaId?: number, apenasPendentes?: boolean, entidadeId?: number, urlContains?: string, ids?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (desde !== undefined && desde !== null) {
            queryParameters = queryParameters.set('desde', <any>desde.toISOString());
        }
        if (ate !== undefined && ate !== null) {
            queryParameters = queryParameters.set('ate', <any>ate.toISOString());
        }
        if (pessoaJuridicaId !== undefined && pessoaJuridicaId !== null) {
            queryParameters = queryParameters.set('pessoaJuridicaId', <any>pessoaJuridicaId);
        }
        if (apenasPendentes !== undefined && apenasPendentes !== null) {
            queryParameters = queryParameters.set('apenasPendentes', <any>apenasPendentes);
        }
        if (entidadeId !== undefined && entidadeId !== null) {
            queryParameters = queryParameters.set('entidadeId', <any>entidadeId);
        }
        if (urlContains !== undefined && urlContains !== null) {
            queryParameters = queryParameters.set('urlContains', <any>urlContains);
        }
        if (ids !== undefined && ids !== null) {
            queryParameters = queryParameters.set('ids', <any>ids);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<Evento>>('get',`${this.basePath}/v1/Notificacoes`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Reenviar Notificações
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1NotificacoesPost(body?: FiltroNotificacoes, observe?: 'body', reportProgress?: boolean): Observable<Array<Evento>>;
    public v1NotificacoesPost(body?: FiltroNotificacoes, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Evento>>>;
    public v1NotificacoesPost(body?: FiltroNotificacoes, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Evento>>>;
    public v1NotificacoesPost(body?: FiltroNotificacoes, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Array<Evento>>('post',`${this.basePath}/v1/Notificacoes`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
